module.exports = __webpack_public_path__ + "static/img/title-bar.19a38bf0.webp";